require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contentModelByIds = void 0;

exports.contentModelByIds = function (contentTypes) {
  return contentTypes.items.reduce(function (outerResult, contentType) {
    outerResult[contentType.name] = contentType.fields.reduce(function (innerResult, field) {
      innerResult[field.id] = field;
      return innerResult;
    }, {});
    return outerResult;
  }, {});
};